/* tslint:disable */

declare var Object: any;
export interface LeaseReviewHistoryInterface {
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class LeaseReviewHistory implements LeaseReviewHistoryInterface {
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: LeaseReviewHistoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LeaseReviewHistory`.
   */
  public static getModelName() {
    return "LeaseReviewHistory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LeaseReviewHistory for dynamic purposes.
  **/
  public static factory(data: LeaseReviewHistoryInterface): LeaseReviewHistory{
    return new LeaseReviewHistory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LeaseReviewHistory',
      plural: 'LeaseReviewHistories',
      path: 'LeaseReviewHistories',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
